import { render, staticRenderFns } from "./Wonder.vue?vue&type=template&id=e250340a"
import script from "./Wonder.vue?vue&type=script&lang=js"
export * from "./Wonder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports